import Button from "../../../../../../components/elements/Button/Button";
import {useIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import {toast} from "react-toastify";
import axios from "axios";
import errorParser from "../../../../../../components/ErrorParser/ErrorParser";
import LoadingComp from "../../../../../../components/elements/LoadingComp/LoadingComp";
import AddFoodMenuForm from "../../../../Nomenclature/Menus/FoodMenus/AddFoodMenuForm";

export default function AddCustomFoodMenu() {

    const intl = useIntl();
    const navigate = useNavigate()
    const jwt = localStorage.getItem('jwt')
    let params = useParams();
    const emptyItem = {
        'title': '',
        'price': 0,
        'products': []
    }

    const [title, setTitle] = useState('')
    const [price, setPrice] = useState(0)
    const [addition, setAddition] = useState(0)
    const [cost, setCost] = useState(0)

    const [items, setItems] = useState([emptyItem])
    const [vat, setVat] = useState(0)
    const [costPerMenu, setCostPerMenu] = useState(false)
    const [pricePerMenu, setPricePerMenu] = useState(false)
    const [loading, setLoading] = useState(true)
    const [vats, setVats] = useState([])
    const [productsOptions, setProductsOptions] = useState([])

    const [saveLoading, setSaveLoading] = useState(false)
    const {context} = useOutletContext()

    useEffect(() => {
        if (parseInt(params.id_menu) !== 0) {
            getData()
        } else {
            getVats()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const getData = async () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API + '/food-menus/' + params.id_menu, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        }).then(async (response) => {
            if (response.data) {
                setTitle(response.data.title)
                setAddition(parseFloat(100 * (response.data.price - response.data.cost) / response.data.cost).toFixed(2))
                setPrice(response.data.price)
                setCost(response.data.cost)
                setCostPerMenu(response.data.cost_per_menu)
                setPricePerMenu(response.data.price_per_menu)
                setVat(response.data.vat)
                setItems(response.data.items)
                getVats()
            }
        })
            .catch(err => {
                errorParser(err, intl)
            })
    }


    const getVats = async () => {
        axios.get(process.env.REACT_APP_API + '/vats', {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let options = []
                response.data.forEach((item) => {
                    options.push({
                        value: item.id,
                        label: item.value,
                    })
                })
                setVats(options)
                getProductsOptions()
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const getProductsOptions = async () => {
        axios.post(process.env.REACT_APP_API + '/menu-products/list/0', {}, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let options = []
                response.data.products.filter(item => item.type !== 'ingredients' && item.category === 'food').forEach((item) => {
                    options.push({
                        value: item.id,
                        label: item.title,
                        price: item.price,
                        cost: item.production_price,
                        unit: item.unit,
                    })
                })
                setProductsOptions(options)
                setLoading(false)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }
    const save = async (e) => {
        e.preventDefault();
        if (vat === 0) {
            toast.error(intl.formatMessage({id: "errors.please_fill_all_fields"}))
            return
        }
        setSaveLoading(true)
        let payload = {
            title: title,
            price: price,
            event_type: params.event_type,
            is_custom: true,
            event: params.id,
            items: items,
            vat,
            cost,
            cost_per_menu: costPerMenu,
            price_per_menu: pricePerMenu,
        }

        if (params.id_menu) {
            payload.replace_food_menu = parseInt(params.id_menu)
        }

        await axios.post(process.env.REACT_APP_API + '/food-menus', payload, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                context.setContentUpdated(false)
                navigate(-1)
            })
            .catch(err => {
                errorParser(err, intl)
            })


        setSaveLoading(false)
    }
    if (loading) {
        return <LoadingComp/>
    }
    return (
        <div className="card">
            <div className={"header"}>
                <p>{intl.formatMessage({id: 'menus.' + (parseInt(params.id_menu) !== 0 ? 'edit_food_menu' : 'add_food_menu')})}</p>
            </div>
            <form onSubmit={(e) => save(e)}>
                <div className={"content"}>
                    <AddFoodMenuForm
                        items={items}
                        setItems={setItems}
                        price={price}
                        setPrice={setPrice}
                        title={title}
                        setTitle={setTitle}
                        vat={vat}
                        setVat={setVat}
                        showEventType={false}
                        context={context}
                        cost={cost}
                        setCost={setCost}
                        costPerMenu={costPerMenu}
                        setCostPerMenu={setCostPerMenu}
                        pricePerMenu={pricePerMenu}
                        setPricePerMenu={setPricePerMenu}
                        addition={addition}
                        setAddition={setAddition}
                        vats={vats}
                        productsOptions={productsOptions}
                    />
                </div>

                <div className={"footer"}>
                    <div className={"row"}>
                        <div className={"col-12 col-md-6"}>
                            <Button
                                className={"btn-light mt-2"}
                                icon={"fa-solid fa-chevron-left"}
                                value={intl.formatMessage({id: 'general.buttons.back'})}
                                onClick={() => {
                                    context.setLeavePage(true)
                                    context.setNextLink('/events/' + params.id + '/food-menu')
                                }}
                            />
                        </div>
                        <div className={"col-12 col-md-6 d-flex"}>
                            <Button
                                className={"btn-secondary mt-2 ms-auto"}
                                icon={"fa-solid fa-plus"}
                                value={intl.formatMessage({id: 'general.buttons.' + (parseInt(params.id_menu) !== 0 ? 'edit' : 'add')})}
                                disabled={saveLoading}
                                loading={saveLoading}
                                type={'submit'}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

